$("header-menu details" ).each(function(){
    $(this).mouseover(function() {
        $(this).attr("open","");
        $(this).child('summary').attr("aria-expanded", "true");
    })
    .mouseout(function() {
         $(this).removeAttr("open","");
        $(this).child('summary').removeAttr("aria-expanded", "true");
    });
});
$(".colseBtn").on("click", function (event) {
  event.preventDefault();
  event.stopPropagation();

  const drawer = document.querySelector("header-drawer");
  const details = document.querySelector(
    "#Details-menu-drawer-container"
  );
  const summary = details?.querySelector(":scope > summary");

  if (drawer && summary && typeof drawer.closeMenuDrawer === "function") {
    drawer.closeMenuDrawer(event.originalEvent || event, summary);
  }

  // Garante que o overlay e o bloqueio desapareçam imediatamente
  details?.removeAttribute("open");
  details?.classList.remove("menu-opening");
  summary?.setAttribute("aria-expanded", "false");

  document.body.classList.remove(
    "overflow-hidden",
    "overflow-hidden-mobile",
    "overflow-hidden-tablet",
    "overflow-hidden-desktop"
  );
});